<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Add status
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .mb-4.text-md.font-semibold Fill the information below
      .text-sm.font-semibold.neutral500--text.mb-2 Status name
      template(v-for="(status, index) in statuses")
        .d-flex.align-center.mb-4
          v-text-field.round-xl(v-model="status.name" placeholder="Enter status name" outlined hide-details)
          v-btn.ml-4(icon color="primary" @click="deleteStatus(status)" v-if="status.name")
            v-icon $yzi-trash-04
      v-btn.button-sm(outlined @click="addStatus" :disabled="emptyStatuses") 
        v-icon.ml-n2(color="neutral700" left) $yzi-plus
        span Add status
    v-divider

    v-card-actions.py-4.pr-6
      v-btn.button-md.primary400--text.underline(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" :loading="isLoading" color="primary" depressed :disabled="emptyStatuses") {{ $t('save') }}

  create-reject-reason-dialog(v-if="showRejectReasonDialog" :open.sync="showRejectReasonDialog")
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import CreateRejectReasonDialog from './CreateRejectReasonDialog.vue';

export default {
  name: 'AddStatusDialog',
  components: { CreateRejectReasonDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    statusName: '',
    status: null,
    showRejectReasonDialog: false,
    isLoading: false,
    statuses: [{
      name: ''
    }]
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    emptyStatuses () {
      return this.statuses.filter(item => item.name.trim().length === 0).length > 0
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteStatus (status) {
      if (this.statuses.length === 1) {
        this.statuses.map(item => item.name = '')
        return
      }
      this.statuses = this.statuses.filter(item => item !== status)
    },
    addStatus () {
      this.statuses.push({ name: ''})
    },
    async save () {
      this.isLoading = true
      let hasError = false
      await this.asyncForEach(this.statuses, async (status) => {
        try {
          const params = { name: status.name }
          await this.$axios.post(`/connect/${this.company.slug}/statuses`, params)
        } catch (error) {
          hasError = true
          let message = this.$t('error_message.unable_to_complete_request')
          if (error.response.data?.detail) {
            message = error.response.data.detail
          }
          this.showMessage(['error', message])
        }
      })
      if (!hasError) {
        this.showMessage(['success', 'Status successfully created'])
        localStorage.setItem('yz_status_onboarding_completed', true)
      }      
      this.isLoading = false
      this.showDialog = false
      this.$emit('added')
    }
  }
}
</script>
